import { createHelpers, createResource } from '@amfintech/refine-react-admin';
import { OtpChallenge, OtpMethod } from '~/api';
import { resourceNames } from './resource-names';
import { formatDate } from '@amfintech/react-admin-ui';

const { defineFields, defineShowPage, defineCardSection } = createHelpers<OtpChallenge>({
  resourceName: resourceNames.otpChallenge,
});

export const otpLogsResource = createResource({
  name: resourceNames.otpChallenge,
  label: 'OTP Logs',
  fields: defineFields([
    'id',
    'consumer',
    'purpose',
    'userId',
    'method',
    'flow',
    'createdAt',
    'expiredOn',
    'retryWaitSeconds',
    'updatedAt',
    'mcasVerificationCode',
    'code',
    'usedAt',
  ]),
  meta: {
    hide: true,
  },
  filterControls: {
    consumer: {
      type: 'text',
      config: {
        label: 'Consumer',
      },
      operator: 'contains',
    },
    createdAt: {
      type: 'daterange',
      config: {
        label: 'Timestamp',
        disabled: {
          after: new Date(),
        },
      },
    },
    method: {
      type: 'select',
      config: {
        label: 'Method',
        options: Object.values(OtpMethod).map((status) => ({ label: status, value: status })),
      },
      operator: 'eq',
    },
  },
  allowCreate: false,
  allowEdit: false,
  allowDelete: false,
  allowDownload: true,
  defaultValues: {},
  list: {
    filters: {
      collapsible: 'expand-by-default',
    },
  },
  defaultSorter: [{ field: 'createdAt', order: 'desc' }],
  columns: ({ LinkToDetails }) => [
    {
      id: 'createdAt',
      header: 'Created At',
      accessorKey: 'createdAt',
      cell: (data) => formatDate(data.getValue<string>(), { formatType: 'dateAndTime' }),
    },
    {
      id: 'userId',
      header: 'User ID',
      accessorKey: 'userId',
    },
    {
      id: 'consumer',
      header: 'Consumer',
      accessorKey: 'consumer',
    },
    {
      id: 'code',
      header: 'OTP Code',
      accessorKey: 'code',
    },
    {
      id: 'purpose',
      header: 'Purpose',
      accessorKey: 'purpose',
    },
    {
      id: 'method',
      header: 'Method',
      accessorKey: 'method',
    },
    {
      id: 'expiredOn',
      header: 'Expired On',
      accessorKey: 'expiredOn',
      cell: (data) => formatDate(data.getValue<string>(), { formatType: 'dateAndTime' }),
    },
    {
      id: 'usedAt',
      header: 'Used At',
      accessorKey: 'usedAt',
      cell: (data) => {
        const value = data.getValue<string>();
        if (!value) {
          return '-';
        } else {
          return formatDate(value, { formatType: 'dateAndTime' });
        }
      },
    },
  ],
});
